import { useImage } from 'global/cnr/contexts/useHelpers/useImage';
import { useContext, useMemo } from 'react';
import { Image } from 'semantic-ui-react';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { gEnums } from '../../enums/globalEnums';
import { _animateTypes } from '../../motions/AnimateComponent';
import MotionComponent from '../../motions/MotionComponent';
import { _longPressTypes, LPW } from 'global/wrappers/LongPressWrapper';
import { FrameworkContext } from 'global/cnr/contexts/FrameworkContent';
import { useStyles } from 'global/cnr/contexts/useHelpers/useStyles';

const Banner = () => {

  const { setStyleAndClass } = useStyles()

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { transition_state, paps_state, currentSettings_state } = states;
  const { landingView, view } = paps_state ?? {}

  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { desktopMode } = framework_state ?? {}

  // Page Context
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { banner: app_banner } = aps_global ?? {};

  // Transition Context
  const { transitions } = transition_state ?? {};
  const transition = transitions ? transitions[_animateTypes.topBanner] : null;
  const { showTransition } = transition ?? {};

  const { banner: bannerFileName, bannerSize, bannerType, bannerDirectUrl } = app_banner ?? {};
  const styleAndClass = setStyleAndClass({ item: gEnums.projectStyles.appBanner })

  const appImage = useImage({ fileName: bannerFileName, fileType: 'image', fullImage: true })
  const { currentUrls } = appImage ?? {}
  const { full: currentUrl } = currentUrls ?? {}

  const isLanding = view === landingView

  const _currentUrl = useMemo(() => {
    switch (bannerType) {
      case gEnums.bannerTypes.directUrl:
        return bannerDirectUrl
      case gEnums.bannerTypes.fromFile:
        return currentUrl
    }
  }, [bannerDirectUrl, currentUrl])

  const bannerImage = () => {
    const imageSize = bannerSize && bannerSize !== 'normal' ? bannerSize : 'large';
    return (
      <Image
        size={imageSize}
        className={`banner-image': 'gen'}`}
        centered
        src={_currentUrl}
        alt=""
        style={{ display: 'block' }}
      />
    );
  };

  const bannerImageDirect = () => {
    const imageSize = bannerSize && bannerSize !== 'normal' ? bannerSize : 'large';
    return (
      <Image
        size={imageSize}
        className={`banner-image': 'gen'}`}
        centered
        src={_currentUrl}
        alt=""
        style={{ display: 'block' }}
      />
    );
  };

  const content_banner = () => {

    switch (bannerType) {
      case gEnums.bannerTypes.directUrl:
        return bannerImageDirect()
      case gEnums.bannerTypes.fromFile:
        return bannerImage()
    }
  }

  const content = () => (
    showTransition ? (
      <MotionComponent transition={transition}>{content_banner()}</MotionComponent>
    ) : (
      content_banner()
    )
  );

  if (!isLanding && !desktopMode) return;

  return <LPW
    longPressType={_longPressTypes.bannerImage}
    opts={{ appImage }}
  >
    {_currentUrl ? (
      <div {...styleAndClass}>{content()}</div>
    ) : (
      <div></div>
    )}
  </LPW>
};

export default Banner;
